import { render } from "./NotificationsOffcanvas.vue?vue&type=template&id=7aac8e69&scoped=true"
import script from "./NotificationsOffcanvas.vue?vue&type=script&lang=js"
export * from "./NotificationsOffcanvas.vue?vue&type=script&lang=js"

import "./NotificationsOffcanvas.vue?vue&type=style&index=0&id=7aac8e69&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aac8e69"]])

export default __exports__